import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./BusinessTravel.css";

function BusinessTravel() {
  return (
    <>
      <div className="business-travel-section container  mb-md-5 mt-5 pt-md-4">
        <div className="row mt-md-5">
          <div className="col-md-12 ">
            <h1 className="text-center headings">
              Reshaping <span> Business Travel</span> With Latest Technology
            </h1>
          </div>
          <div className="row px-lg-5 mlTab">
            <div className="col-lg-4 col-md-4 col-12 mt-lg-5 mt-3  d-flex justify-content-center pleft">
              <div className="BT-box shadow">
                <div className="row">
                  <div className="col-md-12 radius-image">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/images/Global.png"
                      alt=""
                      className="w-100 h-100 img-fluid"
                      loading="lazy"
                    />
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings bT-h5">
                      Combining Reach to the World, Local Expertise, and Agile
                      Technology
                    </h5>
                    <p className="mt-md-3 mt-2 ">
                      The breadth to consistently offer local market knowledge,
                      the scalability to realize optimum savings, and the
                      flexibility to raise issues related to travel.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12 mt-lg-5 mt-3  d-flex justify-content-center pleft">
              <div className="BT-box shadow">
                <div className="row">
                  <div className="col-md-12 radius-image">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/images/Built.png"
                      alt=""
                      className="w-100 h-100 img-fluid"
                      loading="lazy"
                    />
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings bT-h5">
                      Build for Consistency, Simplicity, and Flexibility
                    </h5>
                    <p className="mt-md-3 mt-2 ">
                      We take a highly consultative, curated approach to design
                      unique, simple, and effective global travel solutions that
                      deliver strategic results today as well as in the future.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12 mt-lg-5 mt-3  d-flex justify-content-center pleft">
              <div className="BT-box shadow">
                <div className="row">
                  <div className="col-md-12 radius-image">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/images/Your%20feedback.png"
                      alt=""
                      className="w-100 h-100 img-fluid"
                      loading="lazy"
                    />
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings bT-h5">
                      Your Feedback Drives Our Roadmap
                    </h5>
                    <p className=" mt-md-3 mt-2">
                      We put you front and center of our product and service
                      roadmap, ensuring you benefit first from the fastest, most
                      relevant, and impactful solutions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- .............................tech-solutions-section.................................... --> */}
      <div className="tech-solutions mt-md-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mt-md-5">
              <h3 className="mt-5 text-center headings">
                Discover How Tech Solutions Can Help You and Your Businesses...
              </h3>
            </div>
            <div className="col-md-12 d-flex justify-content-center mt-2 mt-md-4">
              <div className="carouselCaption text-black">
                <a href="/tech-platform">
                  <button className="btn text-black fs-5 fw-bold">
                    CLICK HERE
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- .............................BBT BLeisure Travel-section.................................... --> */}
      <div className="bbt h-auto mt-md-5 w-100 pb-5">
        <div className="container px-md-5 px-4">
          <div className="row text-white">
            <div className="col-md-12 mt-5">
              <h1 className="headings">
                BBT <span> BLeisure </span> Travel
              </h1>
              <p className="fs4 firstP-fs">
                Now, don’t just travel for your meeting to a different city.
                What if corporate employees have the privilege to treat
                themselves lavishly after finishing their meetups?
              </p>
              <p className="secondp secondP-fs">
                BLeisure is all about experiencing the destination while
                attending business meetings. There are several cases when
                travelers are willing to spend more on dining, entertainment,
                and tours because they are sponsored by their companies.
                However, BLeisure travelers may not research it beforehand. Here
                BBT helps them out! We create immersive experiences like
                full-day tours and well-rounded trips for our luxury travelers,
                so they can enjoy themselves to the fullest.
              </p>
              <div className="carouselCaption text-black">
                <a href="/bliesure">
                  <button className="btn text-white p-md-3 mt-1 ps-md-5 pe-md-5 fw-bold">
                    LEARN MORE
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BusinessTravel;
